var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamesLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 124,
    viewBox: "0 0 202 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0498 66.4102H133.2",
    stroke: "#BE4BDB",
    strokeWidth: 1.3224,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.59 114.021H160.97",
    stroke: "#BE4BDB",
    strokeWidth: 1.3224,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4697 96.82L94.8497 95.5",
    stroke: "#BE4BDB",
    strokeWidth: 1.3224,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.04 69.0498L117.33 114.02",
    stroke: "#BE4BDB",
    strokeWidth: 1.3224,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.41 70.3801C115.81 70.3801 122.62 68.3072 122.62 65.7501C122.62 63.193 115.81 61.1201 107.41 61.1201C99.01 61.1201 92.2002 63.193 92.2002 65.7501C92.2002 68.3072 99.01 70.3801 107.41 70.3801Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0498 62.6701C57.8398 61.7201 61.8898 61.1201 66.4098 61.1201C74.8098 61.1201 81.6198 63.1901 81.6198 65.7501C81.6198 68.3101 74.8098 70.3801 66.4098 70.3801C63.8898 70.3801 61.5198 70.1901 59.4298 69.8601",
    fill: "#EEBEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2901 84.9202C90.6903 84.9202 97.5001 82.8472 97.5001 80.2902C97.5001 77.7331 90.6903 75.6602 82.2901 75.6602C73.8898 75.6602 67.0801 77.7331 67.0801 80.2902C67.0801 82.8472 73.8898 84.9202 82.2901 84.9202Z",
    fill: "#EEBEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8298 100.27C105.959 100.27 113.36 98.018 113.36 95.24C113.36 92.462 105.959 90.21 96.8298 90.21C87.7005 90.21 80.2998 92.462 80.2998 95.24C80.2998 98.018 87.7005 100.27 96.8298 100.27Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63 120.4C131.217 120.4 139.8 117.785 139.8 114.56C139.8 111.334 131.217 108.72 120.63 108.72C110.043 108.72 101.46 111.334 101.46 114.56C101.46 117.785 110.043 120.4 120.63 120.4Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56 120.4C180.147 120.4 188.73 117.785 188.73 114.56C188.73 111.334 180.147 108.72 169.56 108.72C158.972 108.72 150.39 111.334 150.39 114.56C150.39 117.785 158.972 120.4 169.56 120.4Z",
    fill: "#EEBEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.29 68.9801C156.53 69.8401 152.67 70.3801 148.4 70.3801C140 70.3801 133.19 68.3101 133.19 65.7501C133.19 63.1901 140 61.1201 148.4 61.1201",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.42 70.3801C33.8202 70.3801 40.63 68.3072 40.63 65.7501C40.63 63.193 33.8202 61.1201 25.42 61.1201C17.0197 61.1201 10.21 63.193 10.21 65.7501C10.21 68.3072 17.0197 70.3801 25.42 70.3801Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0198 93.6504C67.0698 94.4804 69.7198 95.8904 69.7198 97.4904C69.7198 100.05 62.9098 102.12 54.5098 102.12C46.1098 102.12 39.2998 100.05 39.2998 97.4904C39.2998 95.9904 41.6298 94.6604 45.2498 93.8204",
    fill: "#EEBEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.69 49.4096C154.99 47.4296 153.64 45.9196 151.45 45.3096L150.38 41.3496C152.27 40.5196 153.59 38.6496 153.59 36.4496C153.59 33.4996 151.2 31.0996 148.24 31.0996C145.29 31.0996 142.89 33.4896 142.89 36.4496C142.89 38.6396 144.21 40.5196 146.1 41.3496L145.03 45.3096C141.64 46.2496 140.22 49.3496 140.22 53.0296L139.15 64.2596C139.15 65.4396 143.81 66.3996 148.24 66.3996C149.67 66.3996 151.13 66.2996 152.45 66.1196L153.45 55.6696C153.44 53.1296 154.14 50.8796 155.69 49.4096Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.69 49.4092C154.15 50.8792 153.44 53.1292 153.44 55.6792L152.44 66.1292",
    fill: "#EEBEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.69 49.4092C154.15 50.8792 153.44 53.1292 153.44 55.6792L152.44 66.1292",
    stroke: "#EEBEFA",
    strokeWidth: 1.3224,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.451 66.13L152.381 66.91C152.381 68.09 157.041 69.05 161.471 69.05C165.901 69.05 170.561 68.09 170.561 66.91L169.491 55.68C169.491 51.99 168.071 48.89 164.681 47.96L163.601 44C165.491 43.17 166.811 41.3 166.811 39.1C166.811 36.15 164.421 33.75 161.461 33.75C158.511 33.75 156.111 36.14 156.111 39.1C156.111 41.29 157.431 43.17 159.321 44L158.251 47.96C157.211 48.25 156.371 48.76 155.681 49.41",
    fill: "#EEBEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.451 66.13L152.381 66.91C152.381 68.09 157.041 69.05 161.471 69.05C165.901 69.05 170.561 68.09 170.561 66.91L169.491 55.68C169.491 51.99 168.071 48.89 164.681 47.96L163.601 44C165.491 43.17 166.811 41.3 166.811 39.1C166.811 36.15 164.421 33.75 161.461 33.75C158.511 33.75 156.111 36.14 156.111 39.1C156.111 41.29 157.431 43.17 159.321 44L158.251 47.96C157.211 48.25 156.371 48.76 155.681 49.41",
    stroke: "#EEBEFA",
    strokeWidth: 1.3224,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.55 36.3198C86.52 36.8398 84.9 36.7298 83.95 36.0798L78.82 32.5498C77.87 31.8998 76.81 30.4598 76.47 29.3498L72.27 15.7998C71.93 14.6998 72.53 13.4598 73.61 13.0498L86.71 8.07975C87.79 7.66975 89.6 7.52975 90.73 7.76975L96.92 9.08975C98.05 9.32975 99.16 10.4598 99.39 11.5898",
    fill: "#E599F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4397 30.3304L87.5497 36.3204C86.5197 36.8404 85.4497 36.3504 85.1797 35.2304L81.2897 19.2804C81.0197 18.1604 81.6697 16.8804 82.7297 16.4404L97.0897 10.5404C98.1597 10.1004 99.2197 10.6704 99.4497 11.8004L101.98 24.4004",
    fill: "#EEBEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6204 34.9198C84.9404 36.0298 84.4104 36.3998 83.4604 35.7498L78.8104 32.5498C77.8604 31.8998 76.8004 30.4598 76.4604 29.3498L72.3404 16.0198C72.0004 14.9198 72.5904 14.3798 73.6504 14.8298L77.7004 16.5398C78.7604 16.9898 79.8904 18.2698 80.2104 19.3798L84.6204 34.9198Z",
    fill: "#CC5DE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6697 15.73C80.5897 16.15 78.8297 16.16 77.7497 15.76L74.0297 14.37C72.9497 13.97 72.9497 13.3 74.0297 12.89L86.7297 8.06999C87.8097 7.65999 89.6197 7.51999 90.7497 7.75999L96.0797 8.89999C97.2097 9.13999 97.2497 9.67999 96.1797 10.1L81.6697 15.73Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8299 29.89C92.0899 28.8 91.5099 27.8 90.5299 27.64C89.5499 27.49 88.5399 28.25 88.2799 29.33C88.0199 30.42 88.5999 31.42 89.5799 31.58C90.5599 31.74 91.5699 30.98 91.8299 29.89Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3699 20.5902C89.6299 19.5002 89.0499 18.5002 88.0699 18.3402C87.0899 18.1902 86.0799 18.9502 85.8199 20.0302C85.5599 21.1202 86.1399 22.1202 87.1199 22.2802C88.1099 22.4402 89.1099 21.6802 89.3699 20.5902Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4394 27.1693C98.7594 26.0993 98.2294 25.0593 97.2494 24.8593C96.2794 24.6593 95.2394 25.3593 94.9194 26.4393C94.5994 27.5093 95.1394 28.5493 96.1094 28.7493C97.0794 28.9493 98.1194 28.2493 98.4394 27.1693Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5498 17.6595C96.8698 16.5895 96.3398 15.5495 95.3598 15.3495C94.3898 15.1495 93.3498 15.8495 93.0298 16.9295C92.7098 17.9995 93.2498 19.0395 94.2198 19.2395C95.1898 19.4395 96.2298 18.7295 96.5498 17.6595Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.09 25.0201C78.62 23.9501 77.97 23.2101 77.63 23.3601C77.29 23.5101 77.39 24.5001 77.86 25.5701C78.32 26.6401 78.98 27.3901 79.32 27.2301C79.65 27.0801 79.55 26.0901 79.09 25.0201Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8394 9.66994C89.7594 9.97994 88.9794 10.4599 89.0894 10.7499C89.2094 11.0399 90.1794 11.0199 91.2594 10.7199C92.3394 10.4099 93.1194 9.92994 93.0094 9.63994C92.8994 9.34994 91.9194 9.35994 90.8394 9.66994Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1399 10.9697C83.0599 11.2797 82.2799 11.7597 82.3999 12.0497C82.5199 12.3397 83.4899 12.3197 84.5699 12.0197C85.6499 11.7097 86.4299 11.2297 86.3199 10.9397C86.1999 10.6497 85.2199 10.6597 84.1399 10.9697Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9898 12.3604C76.9098 12.6704 76.1298 13.1504 76.2398 13.4404C76.3598 13.7304 77.3298 13.7104 78.4098 13.4104C79.4898 13.1004 80.2698 12.6204 80.1598 12.3304C80.0398 12.0404 79.0698 12.0504 77.9898 12.3604Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.16 18.9801C111.98 18.3901 110.13 18.5101 109.04 19.2601L103.17 23.3001C102.08 24.0501 100.87 25.6901 100.48 26.9501L95.69 42.4501C95.3 43.7101 95.99 45.1301 97.23 45.6001L112.22 51.2901C113.45 51.7601 115.52 51.9201 116.81 51.6401L123.89 50.1201C125.18 49.8401 126.45 48.5601 126.71 47.2601L130.16 30.1301C130.42 28.8401 129.67 27.2901 128.49 26.7001L113.16 18.9801Z",
    fill: "#E599F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.16 18.98C111.98 18.39 110.76 18.95 110.45 20.23L106 38.46C105.69 39.74 106.43 41.2 107.65 41.7L124.07 48.45C125.29 48.95 126.5 48.3 126.76 47.01L130.15 30.13C130.41 28.84 129.66 27.29 128.48 26.7L113.16 18.98Z",
    fill: "#EEBEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.82 20.58C110.18 19.31 109.59 18.88 108.5 19.63L103.18 23.29C102.09 24.04 100.88 25.68 100.49 26.94L95.7801 42.18C95.3901 43.44 96.0701 44.05 97.2801 43.54L101.91 41.58C103.13 41.07 104.42 39.61 104.78 38.34L109.82 20.58Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.43 42.52C105.2 42.04 103.18 42.03 101.94 42.49L97.6898 44.08C96.4498 44.54 96.4498 45.3 97.6898 45.77L112.21 51.28C113.44 51.75 115.51 51.91 116.8 51.63L122.9 50.33C124.19 50.05 124.24 49.44 123.01 48.96L106.43 42.52Z",
    fill: "#CC5DE8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.72 18.8105C112.87 18.8505 113.02 18.9105 113.16 18.9805C113.01 18.9005 112.86 18.8505 112.72 18.8105Z",
    fill: "#E599F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.63 47.4705C126.69 47.3305 126.74 47.1805 126.77 47.0205C126.74 47.1805 126.69 47.3305 126.63 47.4705Z",
    fill: "#E599F7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M124.53 48.5902C124.38 48.5602 124.23 48.5202 124.08 48.4502C124.23 48.5202 124.38 48.5702 124.53 48.5902Z",
    fill: "#E599F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.61 19.7803C110.54 19.9203 110.49 20.0703 110.45 20.2303C110.49 20.0703 110.54 19.9203 110.61 19.7803Z",
    fill: "#E599F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.41 25.7102C118.71 26.9502 118.04 28.1002 116.92 28.2802C115.8 28.4502 114.65 27.5902 114.35 26.3402C114.05 25.1002 114.72 23.9502 115.84 23.7702C116.96 23.6002 118.11 24.4702 118.41 25.7102Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.841 31.6907C117.141 32.9307 116.471 34.0807 115.351 34.2607C114.231 34.4307 113.081 33.5707 112.781 32.3207C112.481 31.0807 113.151 29.9307 114.271 29.7507C115.391 29.5807 116.551 30.4507 116.841 31.6907Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.15 37.93C115.45 39.17 114.78 40.32 113.66 40.5C112.54 40.67 111.39 39.81 111.09 38.56C110.79 37.32 111.46 36.17 112.58 35.99C113.7 35.82 114.85 36.69 115.15 37.93Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.99 28.9904C126.35 30.2204 125.75 31.4004 124.63 31.6304C123.52 31.8604 122.33 31.0504 121.96 29.8304C121.6 28.6004 122.21 27.4204 123.32 27.1904C124.43 26.9604 125.63 27.7704 125.99 28.9904Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73 35.0402C125.09 36.2702 124.49 37.4502 123.37 37.6802C122.26 37.9102 121.07 37.1002 120.7 35.8802C120.34 34.6502 120.95 33.4702 122.06 33.2402C123.17 33.0102 124.37 33.8202 124.73 35.0402Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.35 41.3605C123.71 42.5905 123.11 43.7705 121.99 44.0005C120.88 44.2305 119.69 43.4205 119.32 42.2005C118.96 40.9705 119.57 39.7905 120.68 39.5605C121.8 39.3305 122.99 40.1405 123.35 41.3605Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.56 28.9804C102.08 30.0704 101.44 30.8504 101.14 30.7104C100.84 30.5804 100.98 29.5804 101.46 28.4904C101.94 27.4004 102.58 26.6204 102.88 26.7604C103.19 26.9004 103.04 27.8904 102.56 28.9804Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.21 36.2208C102.68 37.4408 101.93 38.2908 101.54 38.1208C101.15 37.9508 101.27 36.8108 101.8 35.5908C102.33 34.3708 103.08 33.5108 103.47 33.6908C103.85 33.8608 103.74 35.0008 103.21 36.2208Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.04 49.4606C115.8 49.1106 114.91 48.5606 115.04 48.2306C115.17 47.9006 116.29 47.9206 117.52 48.2706C118.76 48.6206 119.65 49.1706 119.52 49.5006C119.39 49.8306 118.28 49.8106 117.04 49.4606Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.38 47.9704C108.14 47.6204 107.25 47.0704 107.38 46.7404C107.51 46.4104 108.63 46.4304 109.86 46.7804C111.1 47.1304 111.99 47.6804 111.86 48.0104C111.73 48.3404 110.62 48.3204 109.38 47.9704Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.34 46.3805C101.1 46.0305 100.21 45.4805 100.34 45.1505C100.47 44.8205 101.59 44.8405 102.82 45.1905C104.06 45.5405 104.95 46.0905 104.82 46.4205C104.69 46.7505 103.58 46.7305 102.34 46.3805Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6802 117.672L48.3506 115.976L46.6543 120.305L50.9839 122.002L52.6802 117.672Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0596 102.93L26.2696 99.0898",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30957 123.24L32.3896 104.06",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.35 78.1796L176.69 73.1396",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.914 49.123L189.826 47.5215L188.225 51.609L192.312 53.2105L193.914 49.123Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.99 9.67969L175.99 24.6797",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.49 1.32031L146.42 15.8703",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4513 25.8139L3.39746 30.4639L8.04746 38.5177L16.1013 33.8677L11.4513 25.8139Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92969 6.90039L44.5997 30.7004",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8301 7L53.9901 28.16",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52 85.7499L154.03 81.8799L153.42 88.5699L159.52 85.7499Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesLeftImage);
export default __webpack_public_path__ + "static/media/gamesLeftImage.a9e58d873b929424d664089a4e3a3f31.svg";
export { ForwardRef as ReactComponent };